export default __webpack_public_path__ + "static/media/litho-inner-page-slider-01.08fb1919.jpg";